import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0,0h24v24h-24Z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,13v0c-1.657,0 -3,-1.343 -3,-3v0c0,-1.657 1.343,-3 3,-3v0c1.657,0 3,1.343 3,3v0c0,1.657 -1.343,3 -3,3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				d: "M12,21c0,0 -7,-5.75 -7,-11c0,-3.866 3.134,-7 7,-7c3.866,0 7,3.134 7,7c0,5.25 -7,11 -7,11Z"
			})
		]
	})
});
export default SvgPinLocation;
